import { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { RecoilRoot, useRecoilState } from 'recoil';

import { activeTabAtom } from './atoms';

import { Box, Paper, Tab, Tabs } from '@mui/material';

import DataQueue from 'components/admin-portal/queues/DataQueue';
import ImportQueue from 'components/admin-portal/queues/ImportQueue';
import ReportQueue from 'components/admin-portal/queues/ReportQueue';
import SchedulingQueue from 'components/admin-portal/queues/SchedulingQueue';
import { TabPanel } from 'components/shared';
import StyledTabs from 'components/shared/StyledTabs';

const QueueTabs: FC = () => {
  const { t } = useTranslation('common');
  const [activeTab, setActiveTab] = useRecoilState(activeTabAtom);

  const onChangeActiveTab = (e, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <StyledTabs>
        <Paper
          square
          sx={{
            position: 'sticky',
            top: 0,
            backgroundColor: '#FFF',
            zIndex: 40
          }}
        >
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            value={activeTab}
            onChange={onChangeActiveTab}
          >
            <Tab key="DATA" label={t(`adminPortal.dataQueue.name`)} value={0} />
            <Tab
              key="SDB_IMPORT"
              label={t(`adminPortal.importQueue.name`)}
              value={1}
            />
            <Tab
              key="REPORT"
              label={t(`adminPortal.reportQueue.name`)}
              value={2}
            />
            <Tab
              key="SCHEDULING"
              label={t(`adminPortal.schedulingQueue.name`)}
              value={3}
            />
          </Tabs>
        </Paper>
        <Box position="relative" p={2}>
          <TabPanel
            index={0}
            value={activeTab}
            title={t('adminPortal.dataQueue.name')}
          >
            <DataQueue />
          </TabPanel>
          <TabPanel
            index={1}
            value={activeTab}
            title={t('adminPortal.importQueue.name')}
          >
            <ImportQueue />
          </TabPanel>
          <TabPanel
            index={2}
            value={activeTab}
            title={t('adminPortal.reportQueue.name')}
          >
            <ReportQueue />
          </TabPanel>
          <TabPanel
            index={3}
            value={activeTab}
            title={t('adminPortal.schedulingQueue.name')}
          >
            <SchedulingQueue />
          </TabPanel>
        </Box>
      </StyledTabs>
    </>
  );
};

const QueueTabsContainer = () => (
  <>
    <RecoilRoot>
      <QueueTabs />
    </RecoilRoot>
  </>
);

export default QueueTabsContainer;
